import { render, staticRenderFns } from "./DeliveryConfigCampaigns.vue?vue&type=template&id=cb52f354&"
import script from "./DeliveryConfigCampaigns.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb52f354')) {
      api.createRecord('cb52f354', component.options)
    } else {
      api.reload('cb52f354', component.options)
    }
    module.hot.accept("./DeliveryConfigCampaigns.vue?vue&type=template&id=cb52f354&", function () {
      api.rerender('cb52f354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/delivery-config/DeliveryConfigCampaigns.vue"
export default component.exports